export enum EmployeeTabType {
  CLOCKED_IN = 'CLOCKED_IN',
  CLOCKED_OUT = 'CLOCKED_OUT',
  ON_BREAK = 'ON_BREAK',
  SHOW_ALL = 'SHOW_ALL',
}

export const EmployeeTabDefault = EmployeeTabType.CLOCKED_IN;
